import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useScheduleStore } from '@/store/useScheduleStore'
import { useDuplicateScheduleStore } from '@/store/useDuplicateScheduleStore'
import { useReserveStore } from '@/store/useReserveStore'

export const useSlotCleanup = () => {
  const pathName = useLocation().pathname
  const slot = useScheduleStore.getState().slot
  const hasDuplicatedSchedules =
    useDuplicateScheduleStore.getState().schedules.length > 0
  const setScheduleData = useScheduleStore.getState().setScheduleData
  const resetReserveExpirationTime =
    useReserveStore.getState().resetReserveExpirationTime

  useEffect(() => {
    const paths = [
      '/',
      '/local',
      '/paciente',
      '/pagamento',
      '/agendar-consulta'
    ]
    if (paths.includes(pathName) && slot?.id && !hasDuplicatedSchedules) {
      setScheduleData('slot', undefined)
      resetReserveExpirationTime()
    }
  }, [
    pathName,
    setScheduleData,
    slot,
    hasDuplicatedSchedules,
    resetReserveExpirationTime
  ])
}
